import { getJson,post,deleteMethod } from '@/api/http';

/** 添加或修改问卷 */
export const addOrEditQusetionnaire = (data,token) =>post(`${config.cpp}handler/v2/paper/byJson`,data,{token})
/** 获取问卷列表 */
export const getPaperList = (params,token)=>getJson(`${config.cpp}handler/v2/paper/list`,params,{token})

/** 获取问卷详情 */
export const getPaperInfo = (params,token) =>getJson(`${config.cpp}handler/v2/paper/info/id`,params,{token})

/** 获取问卷统计信息 */
export const getConfPaperId = (params,token) =>getJson(`${config.cpp}handler/v2/paper/statis/info/confPaperId`,params,{token})

/** 发布问卷 */
export  const releaseQuestionnaire = (data,token)=>post(`${config.cpp}handler/v2/paper/byId`,data,{token})

/** 结束发布问卷 */
export const finishReleaseApi = (data,token)=>post(`${config.cpp}handler/v2/paper/stop`,data,{token})

/** 删除问卷 */
export const deletQuestionnaireApi = (id,token)=>deleteMethod(`${config.cpp}handler/v1/paper/${id}`,{token})
/**
 * 详情
 * @param {*} params 
 * @param {*} token 
 * @returns 
 */
export const getPaperDetail = (params,token)=>getJson(`${config.cpp}handler/v2/paper/completion/detail`,params,{token})
/**
 * 一键发布
 * @param {*} params 
 * @param {*} token 
 * @returns 
 */
export const quickPublishing = (data,token)=>post(`${config.cpp}handler/v2/paper/quick/publishing`,data,{token})
